export enum InfringementLevel {
    INFO = 'info',
    WARN = 'warn',
    ALERT = 'alert',
    MINOR = 'minor',
    SERIOUS = 'serious',
    VERY_SERIOUS = 'very_serious',
    MOST_SERIOUS = 'most_serious',
}
